<shared-breadcrumbs [ComponentData]="BreadcrumbsData"></shared-breadcrumbs>
<div class="pg-content__inner">
  <div class="pg-wrapper" ngClass="{{(deviceValue | async) === DTypes.Desktop ? 'pt-6 pb-4' : 'pt-4 pb-4'}}">
    <div class="row text-center">
      <h1>Новости</h1>
    </div>
    <div class="news-list__create" *ngIf="onAdminRole || onModeratorRole">
      <button class="ui-buttons ui-buttons__gray-small" (click)="news.toggle($event)">
        <span class="pi pi-bars"></span>
      </button>

      <p-menu #news [popup]="true" [model]="NewsListMenu" [appendTo]="'body'" [styleClass]="'p-menu__profile'"></p-menu>
    </div>
  </div>
  <div class="pg-wrapper">
    <div class="news-list__wrapper">
      <ng-container *ngFor="let News of NewsListData;">
        <shared-news-item [NewsItem]="News" [NewsView]="NVType.Preview"></shared-news-item>
      </ng-container>
    </div>
  </div>

  <div class="pg-wrapper">
    <div class="row" *ngIf="pagination.getPaginationValue().loading && this.pagination.getPaginationValue().index > 0">
      <div class="ui-loader__page-light mt-4 mb-6"></div>
    </div>
    <div class="row news-list__pagination" *ngIf="NewsListData.length && pagination.getPaginationValue().count">
      <div *ngFor="let item of [] | paginate: {
          itemsPerPage: pagination.getPaginationValue().size,
          currentPage: pagination.getPaginationValue().index,
          totalItems: pagination.getPaginationValue().count
          }">
      </div>
      <pagination-controls
        class="ui-pagination"
        (pageChange)="onPageChange($event)"
        responsive="true"
        maxSize="5"
        previousLabel="« Назад"
        nextLabel="Вперед »">
      </pagination-controls>

    </div>
  </div>
  <!--<div class="pg-wrapper">
    <div class="news-list__wrapper">
    </div>
  </div>-->
</div>
